<template>
  <div class="widget-card-content">
    <h2 class="content-title">{{title}}</h2>

    <div class="widget-card-bullets">
      <ul>
        <li
            v-for="(text, index) in bullets"
            :key="index"
        >
          <span>{{text}}</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>

export default {
  name: 'WidgetCardMarketingMaterials',
  props: {
    title: {
      type: String,
      default: null,
    },
    iconName: {
      type: String,
      default: null,
    },
    bullets: Array,
  },
};
</script>

<style lang="stylus" scoped>
.widget-card-bullets  {
  margin-top: 20px;
  padding-left: 28px;
  @media (max-width 1170px) {
    margin-top: 24px;
  }
  @media (max-width 600px) {
    padding-left: 0;
  }
  & ul {
    display: flex;
    flex-direction: column;
    margin: -4px;
    @media (max-width 600px) {
      flex-direction: row;
      flex-wrap: wrap;
    }
    @media (max-width 480px) {
      flex-direction: column;
    }
    & li {
      margin: 4px;
      font-size: 18px;
      font-weight: 500;
      line-height: 25.2px;
      position: relative;
      @media (max-width 1170px) {
        font-size: 16px;
        line-height: 22.4px;
      }
      @media (max-width 768px) {
      }
      @media (max-width 600px) {
        display: block;
        width: calc(50% - 8px);
        padding-left: 18px;
      }
      @media (max-width 480px) {
        width: 100%;
        line-height: 19.2px;
      }
      &:before {
        content: '';
        position: absolute;
        top: 7px;
        left: -28px;
        background-color: #68BA62;
        width: 10px;
        height: 10px;
        border-radius: 10px;
        @media (max-width 600px) {
          left: 0;
        }
      }
    }
  }
}
</style>
